import { render, staticRenderFns } from "./PageNurseIns.vue?vue&type=template&id=59d6a240&scoped=true&"
import script from "./PageNurseIns.vue?vue&type=script&lang=js&"
export * from "./PageNurseIns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d6a240",
  null
  
)

export default component.exports